import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class SettingQueryService {
    public GET_PERCENTAGE: any;

    constructor(public apollo: Apollo) {
        this.GET_PERCENTAGE =
            gql`
            query getSettingsValue{                           
                allSettings {
                  edges {
                    node {
                      percentage
                      stripePkLive
                      stripeSkLive
                    }
                  }
                }
              }
        `
    }
    //get charge percentage
    GET_CHARGE_PERCENTAGE() {
        return this.apollo
            .watchQuery({
                query: this.GET_PERCENTAGE
                ,
                fetchPolicy: 'network-only'
            });
    }
}


// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/gql-query-mutation/settings.ts